import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CategoryTitle = styled.div`
  font-family: var(--font-bold);
  font-size: 10px;
`;

const BenefitContainer = styled.div`
  font-size: 10px;
  color: var(--text-primary);
  padding-left: 5px;
`;

type Props = {
  benefits: Record<string, string[]>;
  dataTestId?: string;
};

const CMASummaryTableDataContractBenefit = ({ benefits, dataTestId }: Props) => {
  return (
    <Container data-test-id={dataTestId}>
      {Object.entries(benefits).map(([category, benefitList]) => (
        <div key={category}>
          <CategoryTitle>{category}</CategoryTitle>
          {benefitList.map((benefit) => (
            <BenefitContainer key={benefit}>- {benefit}</BenefitContainer>
          ))}
        </div>
      ))}
    </Container>
  );
};

export default CMASummaryTableDataContractBenefit;
